import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, Zap, Layout } from 'lucide-react';
export function Solution() {
  return <Section className="bg-brand-dark text-white" data-id="element-220">
      <div className="text-center mb-12" data-id="element-221">
        <span className="text-brand-pink font-bold tracking-wider uppercase text-sm" data-id="element-222">
          La Solución
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-white mt-3 mb-6" data-id="element-223">
          La fórmula "Mamá Digital 2.0" <br data-id="element-224" />
          <span className="text-brand-pink" data-id="element-225">(Heylloyd + Gamma)</span>
        </h2>
        <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-226">
          Convierte tu experiencia en un PDF vendible. La mayoría intenta
          hacerlo sola y se traba por no saber qué tema elegir o frustrarse con
          el diseño.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-227">
        {/* Heylloyd Card */}
        <div className="bg-gray-800/50 rounded-2xl p-8 border border-gray-700 hover:border-brand-pink/50 transition-colors" data-id="element-228">
          <div className="w-12 h-12 bg-brand-pink/20 rounded-lg flex items-center justify-center mb-6" data-id="element-229">
            <Zap className="w-6 h-6 text-brand-pink" data-id="element-230" />
          </div>
          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-231">
            Heylloyd te ayuda a:
          </h3>
          <ul className="space-y-3" data-id="element-232">
            {['Generar ideas en minutos', 'Estructurar tu contenido como "pro"', 'Expandir capítulos sin que tú te mates escribiendo'].map((item, i) => <li key={i} className="flex items-start text-gray-300" data-id="element-233">
                <CheckCircle2 className="w-5 h-5 text-brand-pink mt-1 mr-3 flex-shrink-0" data-id="element-234" />
                {item}
              </li>)}
          </ul>
        </div>

        {/* Gamma Card */}
        <div className="bg-gray-800/50 rounded-2xl p-8 border border-gray-700 hover:border-brand-pink/50 transition-colors" data-id="element-235">
          <div className="w-12 h-12 bg-purple-500/20 rounded-lg flex items-center justify-center mb-6" data-id="element-236">
            <Layout className="w-6 h-6 text-purple-400" data-id="element-237" />
          </div>
          <h3 className="text-2xl font-bold text-white mb-4" data-id="element-238">
            Gamma App te ayuda a:
          </h3>
          <ul className="space-y-3" data-id="element-239">
            {['Convertir el contenido en un PDF lindo y moderno', 'Mantener todo limpio, ordenado y profesional', 'Hacerlo desde el celular, sin Canva complicado ni laptop'].map((item, i) => <li key={i} className="flex items-start text-gray-300" data-id="element-240">
                <CheckCircle2 className="w-5 h-5 text-purple-400 mt-1 mr-3 flex-shrink-0" data-id="element-241" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>

      <div className="text-center mt-12" data-id="element-242">
        <p className="text-2xl font-medium text-white" data-id="element-243">
          Tu trabajo no es "ser experta"… <br data-id="element-244" />
          <span className="text-brand-pink font-bold" data-id="element-245">
            Tu trabajo es seguir el paso a paso.
          </span>
        </p>
      </div>
    </Section>;
}